module.exports = __webpack_public_path__ + "static/assets/70af8e411a855e434ccf11129d1e1bf7.svg";